import styled from 'styled-components'

export default styled.section`
  width: 100%;
  padding: 72px 24px 64px;
  box-sizing: border-box;
  background-color: ${ ({ theme }) => theme.colors.landingSurface };
  color: ${ ({ theme }) => theme.colors.landingDark };

  .content {
    max-width: 936px;
    margin: 0 auto;
  }

  h2 {
    margin: 0 0 40px;
    font-size: 48px;
    font-weight: bold;
    line-height: 1.1;
  }

  ul {
    margin: 0;
    padding: 0;
    list-style: none;
  }

  li {
    border-bottom: 1px solid ${ ({ theme }) => theme.colors.greyLight };
  }

  h3 {
    margin: 0;
  }

  button {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    gap: 24px;
    width: 100%;
    min-height: 76px;
    padding: 20px 0;
    border: none;
    background: none;
    color: inherit;
    font-family: inherit;
    font-size: 16px;
    font-weight: 500;
    text-align: left;
    cursor: pointer;

    &:focus-visible {
      outline: 2px solid ${ ({ theme }) => theme.colors.landingPrimary };
      outline-offset: 2px;
    }
  }

  .toggle-icon {
    position: relative;
    flex: 0 0 auto;
    width: 12px;
    height: 12px;

    &::before,
    &::after {
      content: '';
      position: absolute;
      top: 5px;
      left: 0;
      width: 12px;
      height: 2px;
      border-radius: 1px;
      background-color: ${ ({ theme }) => theme.colors.landingPrimary };
      transition: transform 0.3s ease-in-out;
    }

    &::after {
      transform: rotate(90deg);
    }
  }

  button[aria-expanded='true'] .toggle-icon::after {
    transform: rotate(0deg);
  }

  .answer {
    display: grid;
    grid-template-rows: 0fr;
    visibility: hidden;
    opacity: 0;
    transition: grid-template-rows 0.3s ease-in-out, opacity 0.3s ease-in-out, visibility 0.3s;

    &.expanded {
      grid-template-rows: 1fr;
      visibility: visible;
      opacity: 1;
    }
  }

  .answer-content {
    min-height: 0;
    overflow: hidden;
  }

  .answer p {
    margin: 0;
    padding: 0 40px 24px 0;
    font-size: 15px;
    line-height: 1.6;
  }

  @media (prefers-reduced-motion: reduce) {
    .toggle-icon::before,
    .toggle-icon::after,
    .answer {
      transition: none;
    }
  }

  .answer a {
    color: inherit;
    text-decoration: underline;
    word-break: break-word;
  }

  @media screen and (max-width: 768px) {
    padding: 48px 16px 40px;

    h2 {
      margin-bottom: 24px;
      font-size: 36px;
    }

    button {
      font-size: 15px;
    }
  }
`
